import "./HeroComponent.scss"

import WebDeveloperImage from "../../assets/images/web-developer.jpg"
import GamerImage from "../../assets/images/gamer.jpg"
import SupportMainImage from "../../assets/images/support-main.jpg"
import CuberImage from "../../assets/images/cuber.jpg"
import UkuleleImage from "../../assets/images/ukulele.jpg"

function HeroComponent() {

  const cyclingText = [
    "web developer",
    "gamer",
    "LoL support main",
    "cuber",
    "self taught ukulelist",
  ]

  let i = 0, j, k = 0;
  let wordIndex = 0
  let word = cyclingText[wordIndex]

  function addLetters() {
    if (i < word.length) {
      document.querySelector('.hero__cycle-text').innerHTML += word.charAt(i)
      i++
      setTimeout(addLetters, 50)
    } else {
      i = 0
      wordIndex < cyclingText.length - 1 ? wordIndex++ : wordIndex = 0
      word = cyclingText[wordIndex]
      setTimeout(() => {
        removeLetters()
      }, 5000)
    }
  }

  function removeLetters() {
    const notHidden = document.querySelectorAll('.bg__image:not(.bg-hidden)')[0]
    notHidden.style.opacity = "0"
    const currentWord = document.querySelector('.hero__cycle-text').innerHTML
    j = currentWord.length

    if (j > 0) {
      document.querySelector('.hero__cycle-text').innerHTML = currentWord.slice(0, j-1)
      j--
      setTimeout(removeLetters, 50)
    } else {
      addLetters()
      notHidden.classList.toggle('bg-hidden')
      cycleImage()
    }
  }

  function cycleImage() {
    const bgImages = document.querySelectorAll('.bg__image')
    if(k > bgImages.length - 1) k = 0
    bgImages[k].classList.toggle('bg-hidden')
    setTimeout(()=>{
      bgImages[k].style.opacity = "0.8"
      k++
    })
  }

  setTimeout(cycleImage, 1000)
  setTimeout(addLetters, 1000)

  return (
    <div className="hero">
      <div className='hero__bg bg'>
        {/* <img className='bg__image' alt="background"/> */}
        <img className='bg__image bg-hidden' src={WebDeveloperImage} alt="background" />
        <img className='bg__image bg-hidden' src={GamerImage} alt="background" />
        <img className='bg__image bg-hidden' src={SupportMainImage} alt="background" />
        <img className='bg__image bg-hidden' src={CuberImage} alt="background" />
        <img className='bg__image bg-hidden' src={UkuleleImage} alt="background" />
      </div>
      <div className='bg__blur'></div>
      <div className='hero__container'>
        <h1 className='hero__header'>Hi, my name is Li</h1>
        <h2 className='hero__description'>I am a <span className='hero__cycle-text'></span></h2>
      </div>
    </div>
  )
}

export default HeroComponent;